<mat-form-field class="table-autocomplete-field" (click)="initOptionsList()">
  <input matInput [formControl]="control" [matAutocomplete]="autocomplete" [placeholder]="placeholder" #inputElement />
</mat-form-field>

<mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="displayWith" (optionSelected)="handleSelectValue($event)">
  @if (isAutocompleteLoading) {
  <mat-option>
    <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
  </mat-option>
  } @else { @if (hasEmptyOption) {
  <mat-option value="">{{ emptyOptionLabel || '' }}</mat-option>
  } @for (option of autocompleteOptions; track $index) {
  <mat-option [value]="option">
    <span>{{ displayWith(option) }}</span>
  </mat-option>
  } }
</mat-autocomplete>
